module.exports = __webpack_public_path__ + "static/media/2c89e08a.jpg";